import type React from 'react'
import type { InputProps as AriaInputProps } from 'react-aria-components'
import { Input as AriaInput } from 'react-aria-components'

import { cx } from '@portal/styled-system/css'
import { Box } from '@portal/styled-system/jsx'

import { inputRecipe } from './recipe'

export type InputProps = Omit<AriaInputProps, 'size' | 'disabled' | 'color'> & {
    startDecorator?: React.ReactNode
    endDecorator?: React.ReactNode
    classNameInput?: string
    label?: string
    descriptionRight?: React.ReactNode
    description?: string
    descriptionTestId?: string
    descriptionRightTestId?: string
    size?: 'md' | 'lg'
    color?: 'default' | 'success'
    isDisabled?: boolean
    isError?: boolean
    ref?: React.Ref<HTMLInputElement>
}

export function Input(props: InputProps) {
    const {
        startDecorator,
        endDecorator,
        className,
        classNameInput,
        label,
        descriptionRight,
        description,
        descriptionTestId,
        descriptionRightTestId,
        size,
        color: colorVariant,
        isDisabled,
        isError,
        ...ariaInputProps
    } = props

    const classes = inputRecipe({ size, color: colorVariant, isDisabled, isError })

    return (
        <div className={className as string}>
            {label && <div className={classes.label}>{label}</div>}
            <div className={classes.root}>
                {startDecorator && <Box className={classes.startDecorator}>{startDecorator}</Box>}
                <AriaInput
                    {...ariaInputProps}
                    disabled={isDisabled}
                    ref={props.ref}
                    className={cx(classes.input, classNameInput as string)}
                />
                {endDecorator && <Box className={classes.endDecorator}>{endDecorator}</Box>}
            </div>
            <div className={classes.descriptionBlock}>
                {description && (
                    <span className={classes.description} data-testid={descriptionTestId}>
                        {description}
                    </span>
                )}
                {descriptionRight && (
                    <span className={classes.descriptionRight} data-testid={descriptionRightTestId}>
                        {descriptionRight}
                    </span>
                )}
            </div>
        </div>
    )
}
